import angular from 'angular';
import Vue from 'vue';
import 'ngVue';

import MarketingReport from './MarketingReport.vue';

export default angular
  .module('directives.marketingreport', [])
  .directive('dcMarketingReport', [
    'createVueComponent',
    function (createVueComponent) {
      return createVueComponent(Vue.component('DcMarketingReport', MarketingReport));
    }
  ]);
